'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DOM = {};

var __ = require('common/helpers/i18n').__;

var ChangePwdUI = function () {
   function ChangePwdUI() {
      _classCallCheck(this, ChangePwdUI);
   }

   _createClass(ChangePwdUI, null, [{
      key: 'init',
      value: function init() {
         DOM.changePwdLink = $('#change-password-link');
         DOM.returnLink = $('#return-link');

         DOM.changePwdLink.on('click', function (e) {
            var from = DOM.returnLink.attr('href');
            if (!from) return;
            e.preventDefault();
            window.open(DOM.changePwdLink.attr('href'), '_blank');
            window.location = from;
         });
      }
   }]);

   return ChangePwdUI;
}();

module.exports = ChangePwdUI;


//////////////////
// WEBPACK FOOTER
// ./client/js/change-pwd-ui.js
// module id = 138
// module chunks = 0